module.exports = __webpack_public_path__ + "static/media/keyboard-press-long.b302c39e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online-assets/sounds/keyboard-press-long.mp3
// module id = 839
// module chunks = 0